import { DistributionFooterApiModel } from '../../../api/distributions/model/distribution-footer.api.model';
import { DistributionBlockTypeApiEnum } from '../../../api/distributions/enum/distribution-block-type-api.enum';
import { TextStyleModel } from '../../PageBuilder/models/text-style.model';
import { FooterUnsubLanguagesEnum } from '../enum/footer-unsub-languages.emum';

// This does not need to localized, we allow users to edit them in the rich text editor as they want
const defaultFooterText = '[%ADDRESS_PRE_TEXT%]<br>'
    + '[%COMPANY_ORGANIZATION%]<br>'
    + '[%STREET_ADDRESS%], [%CITY%], [%STATE_PROVINCE%], [%ZIP_POSTAL_CODE%]<br>'
    + '[%COUNTRY%]<br>'
    + '<br>'
    + 'For all inquiries, please contact us at: [%CONTACT_INFORMATION%]<br>'
    + '<br>'
    + 'If you would like to opt out of future emails, please [%UNSUBSCRIBE%]<br>';

export class FooterModel {
    addressPreText?: string;
    company?: string;
    streetAddress?: string;
    city?: string;
    province?: string;
    country?: string;
    postalCode?: string;
    senderEmail?: string;
    senderPhone?: string;
    unsubPreText?: string;
    text?: string = defaultFooterText;
    unsubLinkLanguage: FooterUnsubLanguagesEnum;
    unsubLink = '[%SUBSCRIPTION_COMMON_TRACKING_LINK%]';

    constructor(apiModel?: DistributionFooterApiModel) {

        if (apiModel) {
            this.addressPreText = !!apiModel.addressPreText ? apiModel.addressPreText : null;
            this.company = !!apiModel.company ? apiModel.company : undefined;
            this.streetAddress = !!apiModel.streetAddress ? apiModel.streetAddress : undefined;
            this.city = !!apiModel.city ? apiModel.city : undefined;
            this.province = !!apiModel.province ? apiModel.province : null;
            this.country = !!apiModel.country ? apiModel.country : undefined;
            this.postalCode = !!apiModel.postalCode ? apiModel.postalCode : undefined;
            this.senderEmail = !!apiModel.senderEmail ? apiModel.senderEmail : undefined;
            this.senderPhone = !!apiModel.senderPhone ? apiModel.senderPhone : undefined;
            this.unsubPreText = !!apiModel.unsubPreText ? apiModel.unsubPreText : null;
            this.text = (apiModel.text !== null && apiModel.text !== undefined) ? apiModel.text : defaultFooterText;
            this.unsubLinkLanguage = apiModel.unsubLinkLanguage ? apiModel.unsubLinkLanguage : FooterUnsubLanguagesEnum.english;

            // Deal with backward compatibility issue
            // We now hide unsubscribe pre text field, and user uses rich text editor to change it as needed.
            // If user has it stored, we replace the rich editor text "If you would like to opt out of future emails, please" with it, and empty unsubPreText
            if (this.unsubPreText?.trim()) {
                this.text.replace('If you would like to opt out of future emails, please', this.unsubPreText.trim());
                this.unsubPreText = '';
            }
        }
    }

    toApiModel(styles: TextStyleModel): DistributionFooterApiModel {
        return {
            type: DistributionBlockTypeApiEnum.footer,
            styles: !!styles ? JSON.stringify(styles.toBlockStyle()) : null,
            customStyleId: !!styles && Number.isInteger(styles.styleState) ? styles.styleState : null,
            addressPreText: this.addressPreText?.trim() ?? null,
            company: this.company?.trim(),
            streetAddress: this.streetAddress?.trim(),
            city: this.city?.trim(),
            province: this.province?.trim() ?? null,
            country: this.country,
            postalCode: this.postalCode?.trim(),
            senderEmail: this.senderEmail?.trim(),
            senderPhone: this.senderPhone?.trim(),
            unsubPreText: this.unsubPreText?.trim() ?? null,
            // @Hack B/E does not allow emplty string. Here we use a space to indicate all footer text is removed by users
            text: (this.text === '') ? ' ' : this.text,
            unsubLinkLanguage: this.unsubLinkLanguage ?? '',
        } as DistributionFooterApiModel;
    }

    clone(): FooterModel {
        return new FooterModel(this.toApiModel(null));
    }

    equals(other: FooterModel): boolean {
        for (const field of Object.keys(this)) {
            if (this[field] !== other[field]) {
                return false;
            }
        }

        return true;
    }
}
